export const PEXELS_API_BASE_URL = 'https://api.pexels.com/v1';

export const UNSPLASH_API_BASE_URL = 'https://api.unsplash.com';
export const UNSPLASH_AUTH_HEADER = {
  Authorization: 'Client-ID OsA14RaGpD-tovYBxCRxPFVUcqT9hi7Pq50YiQdzYJ4'
}

export const PIXABAY_API_BASE_URL = 'https://pixabay.com/api/';
export const PIXABAY_ACCESS_KEY = '32592924-9e7766770fda1b8dc2c8eb1a2'
export const PIXABAY_COLLECTIONS = [
  "Nature", "Animals", "Cityscapes", "People", "Business",
  "Technology", "Food", "Health", "Travel", "Art",
  "Education", "Sports", "Transportation", "Holidays", "History",
  "Science", "Environment", "Abstract"
].map((title, index) => {
  return { id: title, title: title };
});

export const PEXELS_AUTH_HEADER = {
  Accept: "application/json",
  "Content-Type": "application/json",
  Authorization:
    "563492ad6f917000010000010bb70de2f0f5410db72aa3661e7ef944",
}